import { Grid, Box } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import {
  Label,
  WsButton,
  WsDateTimePicker,
  WsSelect,
  WsTypography,
  WsTypoVariants,
  WsColors,
} from 'wisestep-base';

import RecruiterProfileDetails from '../../RecruiterProfileDetails';

import ActivityStatus from './ActivityStatus';

const MyActivity = () => {
  const entityList = [
    {
      label: 'All',
      value: 'All',
    },
    {
      label: 'Jobs',
      value: 'Jobs',
    },
    {
      label: 'Mappings',
      value: 'Mappings',
    },
    {
      label: 'Submitted Candidates',
      value: 'SubmittedCandidates',
    },
    {
      label: 'Tasks',
      value: 'Tasks',
    },
    {
      label: 'Assigned Jobs',
      value: 'AssignedJobs',
    },
    {
      label: 'Teams',
      value: 'Teams',
    },
    {
      label: 'Team Members',
      value: 'TeamMembers',
    },
    {
      label: 'Login',
      value: 'Login',
    },
  ];
  const methods = useForm();
  return (
    <RecruiterProfileDetails>
      <Box sx={{ backgroundColor: WsColors.White }} pl={4}>
        <Grid item xs={12} container py={2}>
          <WsTypography variant={WsTypoVariants.TITLE}>My Activity</WsTypography>
        </Grid>
        <Grid container component="form" spacing={2} pt={2}>
          <FormProvider {...methods}>
            <Grid item xs={9}>
              <Label>Entity</Label>
              <WsSelect name="entity" label="" selectArray={entityList} size="medium" />
            </Grid>
            <Grid item xs={4}>
              <Label>From Date</Label>
              <WsDateTimePicker name="" label="" disablePast={true} size="small" />
            </Grid>
            <Grid item xs={4}>
              <Label>To Date</Label>
              <WsDateTimePicker name="" label="" disablePast={true} size="small" />
            </Grid>
            <Grid item xs={2} alignSelf="self-end" pb={1}>
              <WsButton size="large">Search</WsButton>
            </Grid>
          </FormProvider>
        </Grid>
        <ActivityStatus />
      </Box>
    </RecruiterProfileDetails>
  );
};

export default MyActivity;
